import React from "react";
import { 
    CartesianGrid, 
    Legend, 
    Line, 
    LineChart, 
    ResponsiveContainer, 
    Tooltip, 
    XAxis, 
    YAxis 
} from 'recharts';
import { colorScheme } from "./CalligraphyTab"
import { useTranslation } from "react-i18next";

export interface CalligraphyTrendChartProps {
    data: CalligraphyTrendChartData[],
    dataKey: string,
    calligraphyType: string[],
    xLabel: string | undefined,
    yLabel: string | undefined,
    tooltipClassifier: string | undefined,
}

type CalligraphyTrendChartData = {
    date: string
} & {
    [key: string]: number
}

export const CalligraphyTrendChart = (props: CalligraphyTrendChartProps) => {
    const { t, i18n } = useTranslation();

    return (
        <ResponsiveContainer width="100%" height={288}>
            <LineChart
              width={1}
              height={288}
              margin={{
                top: 15, right: 30, left: 10, bottom: 15,
              }}
              data={props.data}
              >
                <CartesianGrid />
                <XAxis 
                    dataKey={props.dataKey} 
                    name={props.dataKey} 
                    label={{ 
                        value: props.xLabel, 
                        dy: 20 
                    }}
                />
                {
                    i18n.language === "zh" ?
                    (
                        <YAxis 
                            label={{ 
                                value: props.yLabel, 
                                position: "insideLeft", 
                                angle: -90, 
                                dy: 30
                            }} 
                            domain={props.yLabel === "%" ? [0, 100] : undefined} 
                        />  
                    )
                    :
                    (
                        <YAxis 
                            label={{ 
                                value: props.yLabel, 
                                position: "insideLeft", 
                                angle: -90, 
                                dy: 45 
                            }} 
                            domain={props.yLabel === "%" ? [0, 100] : undefined} 
                        />
                    )
                }
                <Tooltip 
                    cursor={{ strokeDasharray: '3 3' }} 
                    formatter={(value: any) => { 
                        return isNaN(value as any) ? "-" : Math.round((value as number) * 100) / 100 + (props.tooltipClassifier === undefined ? "" : props.tooltipClassifier) }} 
                />
                <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px' }} />
                {
                    props.calligraphyType.map((cType, index) => {
                        return (<Line key={cType} name={(i18n.exists(`calligraphy_type.${cType}`)) ? t(`calligraphy_type.${cType}` as unknown as TemplateStringsArray) : cType} type={"monotone"} dataKey={cType} stroke={colorScheme[index]} dot={true} connectNulls={true} />)
                    })
                }
            </LineChart>
        </ResponsiveContainer>
    );
}